import { Typography } from "@mui/material";
import MultiFileUpload from "../../fileUpload/MultiFileUpload";

const OtherDocuments = () => {
    return (
        <div>
            <Typography variant="h5" gutterBottom sx={{ textTransform: "capitalize", fontSize: "1.5rem" }}>
                Eklemek istediğiniz başka dökümanlar varsa, buradan ekleyebilirsiniz.
            </Typography>
            <MultiFileUpload />
        </div>
    )
}

export default OtherDocuments